import Vue from 'vue';

export default function () {
  const composemessage = new Vue({
    name: 'composemessage',
    el: '#js-message-compose',
    delimiters: ['#{', '}'],
    data() {
      return {
        allowedForButton: true,
        allowedForYoutube: true,
        allowedForImage: true,
        button: false,
        youtube: false,
        image: false,
      }
    },
    methods: {
      insertButton: function() {
        this.button = !this.button;
      },

      insertYoutube: function() {
        this.allowedForImage = !this.allowedForImage;
        this.youtube = !this.youtube;
      },

      insertImage: function() {
        this.allowedForYoutube = !this.allowedForYoutube;
        this.image = !this.image;
      },
    },
  });
};
